var _rect, _rect2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4068_1969)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -9.98152,
    y: -9.98152,
    width: 118.963,
    height: 118.963
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4.99px)",
      clipPath: "url(#bgblur_1_4068_1969_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 9.98152,
    width: 99,
    height: 99,
    rx: 19.8,
    fill: "white",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.16406,
    y: 8.27734,
    width: 82.3279,
    height: 82.3279,
    rx: 16.4656,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 43.3125C39 41.2796 39 40.2631 39.6316 39.6316C40.2631 39 41.2796 39 43.3125 39C45.3454 39 46.3619 39 46.9934 39.6316C47.625 40.2631 47.625 41.2796 47.625 43.3125V57.6875C47.625 59.7204 47.625 60.7369 46.9934 61.3685C46.3619 62 45.3454 62 43.3125 62C41.2796 62 40.2631 62 39.6316 61.3685C39 60.7369 39 59.7204 39 57.6875V43.3125Z",
    fill: "#1E1F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3744 43.3125C53.3744 41.2796 53.3744 40.2631 54.0059 39.6316C54.6376 39 55.654 39 57.6869 39C59.7199 39 60.7363 39 61.3679 39.6316C61.9994 40.2631 61.9994 41.2796 61.9994 43.3125V57.6875C61.9994 59.7204 61.9994 60.7369 61.3679 61.3685C60.7363 62 59.7199 62 57.6869 62C55.654 62 54.6376 62 54.0059 61.3685C53.3744 60.7369 53.3744 59.7204 53.3744 57.6875V43.3125Z",
    fill: "#1E1F26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_4068_1969_clip_path",
    transform: "translate(9.98152 9.98152)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 99,
    rx: 19.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4068_1969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 99,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPause);
export default __webpack_public_path__ + "static/media/VIDEO-PAUSE.e080508b144099c509e98c918f18ddc0.svg";
export { ForwardRef as ReactComponent };